"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _gerenciatdUnifiedicons = require("@bit/gerenciatd.unifiedicons.svg-icon");

var _jsxRuntime = require("react/jsx-runtime");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var pathLight = /*#__PURE__*/(0, _jsxRuntime.jsx)(_react.Fragment, {
  children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "M614.5 442c14-81.9 15.7-263 15.8-318.3-64.7 5.6-103.1-20.3-140.3-45.1-36.1-24.2-73.5-49.2-138-49.2h-.2c-64.5 0-101.9 25-138.1 49.2-37.5 24.9-76.7 50.4-140.2 45.3.2 55.6 2 236.3 16.1 318 17.7 103 223.7 210.5 262.3 229.9 38.6-19.3 244.8-126.9 262.6-229.8zm44.9-334.8c0 9.8.6 240.4-16.3 339.8-22 127.9-274.2 249.3-284.9 254.4a14.2 14.2 0 0 1-12.4 0C335 696.3 83.1 574.9 61.1 447c-17.3-99.4-16.6-330-16.6-339.8.1-8.1 6.7-14.6 14.7-14.5 1.1 0 2.2.1 3.3.4 62.3 9.8 96.1-12.8 135.3-39C235.6 28.7 278.5 0 351.8 0h.2c73.3.1 116.2 28.8 154.1 54.1 39.1 26.1 72.9 48.8 135.4 39 4.3-.6 8.7.5 12.2 3.2 3.3 2.6 5.4 6.6 5.7 10.9zM484.7 241.4c5.6-5.7 14.8-5.7 20.4-.1l.1.1c5.7 5.7 5.7 15 0 20.7L307.7 461.4c-5.6 5.7-14.7 5.7-20.4.1l-.1-.1-88.7-89.5c-5.7-5.7-5.7-15 0-20.7 5.6-5.7 14.8-5.7 20.4-.1l.1.1 78.4 79.1 187.3-188.9z"
  })
});
var pathMedium = /*#__PURE__*/(0, _jsxRuntime.jsx)(_react.Fragment, {
  children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "M601.4 438.9c13-76.2 15.1-241 15.4-302.7-60 2.9-97.6-21.9-133.9-46.2-36-24.1-70-46.9-130.9-47h-.2c-60.9 0-94.9 22.8-131 47-36.2 24.2-73.4 49-133.8 46.2.3 61.7 2.4 226.5 15.6 302.7 14.7 85.2 177 182.4 249.3 218.5 72.4-36.1 234.9-133.5 249.5-218.5zm58-326.8c0 9.6.7 236.2-16 334.2-22.2 128.9-271.7 249.4-282.3 254.5-2.9 1.4-6 2-9.1 2-3.1 0-6.2-.7-9.1-2.1-10.6-5-259.9-125.6-282.1-254.4-17-98-16.4-324.6-16.3-334.2 0-6.6 3.1-12.8 8.2-16.9 5.2-4.1 11.9-5.4 18.2-3.9 57.6 9.1 88-11.4 126.5-37.2C235.3 28.7 278.2 0 351.9 0h.3c73.7.1 116.5 28.8 154.4 54.2 38.5 25.8 69 46.2 127.3 37.1 6.1-1 12.9.7 17.6 4.8 4.6 3.9 7.8 9.8 7.9 16zM298.8 418.6l177.9-180c8.3-8.4 21.8-8.4 30.1 0s8.3 22 0 30.4L313.9 464.2c-4 4-9.4 6.3-15 6.3s-11.1-2.3-15-6.3l-86.6-87.7c-8.3-8.4-8.3-22 0-30.4 8.3-8.4 21.8-8.4 30.1 0l71.4 72.5z"
  })
});
var pathSolid = /*#__PURE__*/(0, _jsxRuntime.jsx)(_react.Fragment, {
  children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "M659.4 112.1c0 9.6.6 236.2-16 334.2C621.2 575.2 371.6 695.7 361 700.7c-5.7 2.7-12.4 2.7-18.2 0-10.6-5.1-259.9-125.6-282.1-254.5-17-98-16.4-324.6-16.3-334.2 0-6.6 3.1-12.8 8.2-16.9 5.1-4 11.9-5.5 18.2-3.9 57.6 9.1 88-11.4 126.5-37.2 37.9-25.2 80.8-54 154.5-54h.2c73.7.1 116.5 28.8 154.4 54.2 38.5 25.8 69 46.2 127.3 37 12-2 23.4 6.2 25.4 18.2l.3 2.7zM298.8 418.6l-71.6-72.4c-8.2-8.3-21.5-8.4-29.8-.3l-.3.3c-8.3 8.4-8.3 22 0 30.4l86.7 87.7c8.2 8.3 21.7 8.3 29.9.1l.1-.1 193-195.2c8.3-8.4 8.3-22 0-30.4-8.2-8.3-21.5-8.4-29.8-.3l-.3.3c-.1-.1-177.9 179.9-177.9 179.9z"
  })
});

var MpaUp = function MpaUp(props) {
  var kind = props.kind;
  var path = null;

  switch (kind) {
    case _gerenciatdUnifiedicons.SVG_ICON_KIND.LIGHT:
      path = pathLight;
      break;

    case _gerenciatdUnifiedicons.SVG_ICON_KIND.SOLID:
      path = pathSolid;
      break;

    default:
      path = pathMedium;
  }

  var Icon = (0, _gerenciatdUnifiedicons.CreateSvgIcon)(path, "MpaUp-".concat(kind));
  var viewBox = props.viewBox,
      mainDimension = props.mainDimension;

  if (!viewBox) {
    viewBox = '-10 -10 720 720';
  }

  if (!mainDimension) {
    mainDimension = 'both';
  }

  return /*#__PURE__*/(0, _jsxRuntime.jsx)(Icon, _objectSpread(_objectSpread({}, props), {}, {
    viewBox: viewBox,
    mainDimension: mainDimension
  }));
};

var _default = MpaUp;
exports["default"] = _default;

//# sourceMappingURL=index.js.map